export default "__VITE_ASSET__B$GkuHiW__"